export function calculateVisibleFolders(container, measureRow, measureFolderRefs, fullPath, arrowWidth, fixedElementsWidth = 0) {
  if (!container.value || !measureRow.value || !fullPath || fullPath.length === 0) {
    return null
  }

  const containerWidth = container.value.offsetWidth
  const folders = fullPath
  let totalWidth = fixedElementsWidth
  let i = 0

  for (; i < folders.length; i++) {
    const el = measureFolderRefs.value[i]
    if (!el) break
    // Predict width if we add this folder, plus the arrow
    let nextWidth = totalWidth + arrowWidth + el.offsetWidth
    if (nextWidth > containerWidth) break
    totalWidth = nextWidth
  }

  return i
}
